import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ICartDetails } from '../appModels/ICartDetails';
import { CheckoutResolver } from '../pages/checkout/services/checkout.resolver';
import { KioskSettingsService } from '../appServices/kiosk-settings.service';
import { OrderTypeResolver } from './order-type.resolver';
import { CheckoutHelper } from '../pages/checkout/services/checkout.helper';

@Injectable({
    providedIn: 'root'
})
export class CartStorage {

    tipAmount = 0;
    cart = new BehaviorSubject<ICartDetails[]>([]);
    coupon = new BehaviorSubject<any>({ couponCode: null, couponValue: 0 });
    couponValue: number = 0;
    couponCode!: String;

    tax: any;

    constructor(
        private checkoutHelper: CheckoutHelper
    ) {
        const cart_ = sessionStorage.getItem('cart');
        if (cart_) {
            this.cart.next(JSON.parse(cart_));
        }
        this.getTipAmount();
        this.getCoupon();
        this.subscribeTax();
    }


    /**
* get Tax
*/
    subscribeTax() {
        this.checkoutHelper.tax.subscribe(res => {
            this.tax = res;
        })
    }
    /**
     * add product in cart
     * @param cartDetail 
     */
    addProductInCart(cartDetail: ICartDetails) {

        const cartCopy = [...this.cart.value, cartDetail];
        this.cart.next(cartCopy);
        this.updateSessionStorage();
    }

    /**
     * remove product from cart
     * @param index 
     */
    removeProductFromCart(index: number) {
        const cartCopy = [...this.cart.value];
        cartCopy.splice(index, 1);
        this.cart.next(cartCopy);
        this.updateSessionStorage();
    }

    /**
     * update product in cart
     * @param index 
     * @param cartDetail 
     */
    updateProductInCart(index: number, cartDetail: ICartDetails) {
        const cartCopy = [...this.cart.value];
        cartCopy[index] = cartDetail;
        this.cart.next(cartCopy);
        this.updateSessionStorage();
    }

    /**
     * get cart details by index
     * @param index 
     */
    getCartDetailsByIndex(index: number) {
        return JSON.parse(JSON.stringify(this.cart.value[index]));
    }

    /**
     * clear cart
     */
    clearCart() {
        this.cart.next([]);
        this.clearSessionStorage();
    }
    /**
     * clear cart without dialog
     */
    public clearCartWithOutDialog() {
        this.cart.next([]);
        this.clearSessionStorage();
    }

    /**
     * update session storage
     */
    private updateSessionStorage() {
        sessionStorage.setItem('cart', JSON.stringify(this.cart.value));
    }

    /**
     * clear session storage
     */
    private clearSessionStorage() {
        sessionStorage.removeItem('cart');
    }


    // ######### helper methods

    /**
     * calculate per item price
     * @param item 
     */
    public calculatePerItemPrice(item: any): void {
        let price = item.productModel.basePrice;
        if (item.productModel.discount) {
            price = item.productModel.discount.discount;
        }
        item.cartDetailsVariantModelList.forEach((variant: any) => {
            price = price + variant.price;
        });
        item.cartDetailsAddOnModelList.forEach((addOn: any) => {
            price = price + addOn.addOnModel.addOnPrice;
        });
        price = price * item.quantity;
        item.price = price;
    }

    /**
     * get total price of cart
     * @param cartDetails 
     */
    public totalPriceOfCart(): number {
        let total = 0;
        if (this.cart.value) {
            this.cart.value.forEach(element => {
                total = total + element.price;
            });
        }
        return total;
    }

    /**
     * calculate total tax
     */
    public calculateTax(): number {
        return (this.totalPriceOfCart() + this.tipAmount) * this.tax / 100;
    }

    /**
     * calculate total
     */
    public calculateTotal(): number {
        // return this.calculateTax(tax) + this.totalPriceOfCart() + this.tipAmount - this?.couponValue;
        // TODO - add coupon
        return this.calculateTax() + this.totalPriceOfCart() + this.tipAmount;
    }

    /**
   * get Tip Amount
   */
    getTipAmount(): void {
        this.checkoutHelper.tipAmount.subscribe(res => {
            this.tipAmount = res;
        });
    }

    /**
     * get coupon
     */
    getCoupon(): void {
        this.coupon.subscribe(res => {
            this.couponValue = res.couponValue;
            this.couponCode = res.couponCode;
        });
    }

}